import "./styles.css";

export const CitySelect = ({ notify }) => {
  const cities = [
    "Agrigento",
    "Agropoli",
    "Albenga",
    "Alessandria",
    "Alghero",
    "Alta Badia",
    "Amalfi",
    "Ancona",
    "Andalo",
    "Andria",
    "Anzio",
    "Aosta",
    "Arenzano",
    "Arezzo",
    "Ascoli Piceno",
    "Asti",
    "Avellino",
    "Bari",
    "Barletta",
    "Belluno",
    "Benevento",
    "Bergamo",
    "Biella",
    "Bologna",
    "Bolzano",
    "Bordighera",
    "Bormio",
    "Brescia",
    "Brindisi",
    "Brixen",
    "Cagliari",
    "Caltanissetta",
    "Campobasso",
    "Canazei",
    "Carbonia",
    "Carpi",
    "Carrara",
    "Caserta",
    "Castelrotto",
    "Catania",
    "Catanzaro",
    "Cervinia",
    "Cesena",
    "Chiavari",
    "Chieti",
    "Chioggia",
    "Civitavecchia",
    "Como",
    "Cortina d'Ampezzo",
    "Cosenza",
    "Courmayeur",
    "Cremona",
    "Crotone",
    "Cuneo",
    "Dolomiti Superski",
    "Enna",
    "Faenza",
    "Fano",
    "Fermo",
    "Ferrara",
    "Finale Ligure",
    "Fiumicino",
    "Florence",
    "Foggia",
    "Folgarida",
    "Forlì",
    "Forte dei Marmi",
    "Frosinone",
    "Genoa",
    "Gorizia",
    "Grosseto",
    "Imola",
    "Imperia",
    "Isernia",
    "La Maddalena",
    "La Spezia",
    "La Thuile",
    "Lamezia Terme",
    "L'Aquila",
    "Latina",
    "Lecce",
    "Lecco",
    "Legnano",
    "Livigno",
    "Livorno",
    "Loano",
    "Lodi",
    "Lucca",
    "Macerata",
    "Madonna di Campiglio",
    "Mantua",
    "Marsala",
    "Massa",
    "Matera",
    "Mazara del Vallo",
    "Merano",
    "Messina",
    "Mestre",
    "Milan",
    "Modena",
    "Modica",
    "Moena",
    "Monte Rosa",
    "Montepulciano",
    "Monza",
    "Naples",
    "Novara",
    "Nuoro",
    "Olbia",
    "Oristano",
    "Ortisei",
    "Padova",
    "Palermo",
    "Parma",
    "Passo del Tonale",
    "Passo Rolle",
    "Pavia",
    "Perugia",
    "Pesaro",
    "Pescara",
    "Pescasseroli",
    "Piacenza",
    "Pisa",
    "Pistoia",
    "Pordenone",
    "Porto Cervo",
    "Porto Torres",
    "Portoferraio",
    "Portofino",
    "Positano",
    "Potenza",
    "Pozzuoli",
    "Prato",
    "Ragusa",
    "Rapallo",
    "Ravello",
    "Ravenna",
    "Reggio Calabria",
    "Reggio Emilia",
    "Rieti",
    "Rimini",
    "Riomaggiore",
    "Rome",
    "Rovigo",
    "Salerno",
    "Sanremo",
    "Santa Margherita Ligure",
    "Sassari",
    "Savona",
    "Siena",
    "Sondrio",
    "Sorrento",
    "Syracuse",
    "Taormina",
    "Taranto",
    "Teramo",
    "Terni",
    "Tivoli",
    "Torre del Greco",
    "Trani",
    "Trapani",
    "Trento",
    "Treviso",
    "Trieste",
    "Turin",
    "Udine",
    "Urbino",
    "Val di Fassa",
    "Val Gardena",
    "Valle Isarco",
    "Varazze",
    "Varese",
    "Venice",
    "Ventimiglia",
    "Verbania",
    "Vercelli",
    "Verona",
    "Viareggio",
    "Vibo Valentia",
    "Vicenza",
    "Viterbo",
  ];
  const cityChange = (e) => {
    const value = e.target.value;
    notify(value);
  };

  return (
    <div className="citySelectorWrapper">
      <select onChange={cityChange}>
        <option disabled>Seleziona una città</option>
        {cities.map((city, id) => (
          <option key={id}>{city}</option>
        ))}
      </select>
    </div>
  );
};
